const MainErrorDC = () => (
  <div className="flex flex-col items-center justify-center max-md:my-10 md:my-20 px-4">
    <div className="text-dc-vermilion max-md:text-[44px] md:text-[72px] font-bold">500</div>
    <h1 className="font-bold mt-4 text-xl text-dc-cod-gray max-w-100">Hang Tight!</h1>
    <p className="mt-2 text-dc-cod-gray max-w-100 text-center">
      We&apos;re making some updates behind the scenes. See you again soon!
    </p>
    <a
      className="mt-7 h-10 w-50 flex items-center justify-center text-center font-bold rounded-lg no-underline default-transition text-white bg-dc-vermilion hover:bg-dc-rock-spray"
      href={'/'}
    >
      Home
    </a>
  </div>
);

export default MainErrorDC;
